/* eslint-disable import/no-unresolved */

import moment from "moment";
import API_URLS from "src/config/API_URLS";
import { NomineeFields } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { calcAgeFromToday } from "src/helpers/FormDetails/ProposalDetails/resources";
import axiosInstance from "src/utils/Axios/axiosInstance";

const getNomineeDetails = async ({ memberId, nomineeDetails }: any) => {
  const existingDateFormat = "DD/MM/YYYY";
  const dateFormat = "YYYY-MM-DD";
  // const nomineeDetails = useAppSelector((state) => state.proposerDetails.nominee);
  try {
    const updatedNomineeDetails = nomineeDetails?.nominee.map((item: NomineeFields) => {
      const isMinor = calcAgeFromToday(item?.dob) < 18;
      let obj: any = {
        fullName: item.fullName,
        gender: item.genderCode || null,
        dob: moment(item.dob, existingDateFormat).format(dateFormat),
        email: item.email || null,
        bankName: item.bankName || null,
        bankAccountNumber: item.bankAccountNumber || null,
        ifscCode: item.ifscCode || null,
        // captureBankDetails: item.captureBankDetails,
        // captureAppointeeAddress:
        // item?.captureAppointeeAddress || false,
        sharePercentage: item.share,
        mobileNo: item.mobileNo || null,
        relationshipWithPrimary: item.relationshipCode,
        address: item.address || null,
        isMinor,
        isAddressSameAsProposer: item.isAddressSame,
        pincode: item.pincode || null,
        title: item.titleCode
      };

      if (item.id) obj = { ...obj, id: item.id };
      else obj = { ...obj, memberId };

      if (isMinor) {
        obj = {
          ...obj,
          appointeeName: item.appointeeName,
          appointeeRelationship: item.appointeeRelationCode,
          appointeeDob: moment(item.appointeeDob, existingDateFormat).format(dateFormat),
          appointeeGender: item.appointeeGenderCode,
          appointeePincode: item.appointeePincode || null,
          appointeeAddress: item.appointeeAddress || null,
          isAppointeeAddressSameAsProposer: item.isAppointeeAddressSameAsProposer,
          appointeeTitle: item.appointeeTitleCode,
          appointeeMobileNo: item.appointeeMobileNo || null,
          appointeeEmail: item.appointeeEmail || null,
          appointeeBankName: item.appointeeBankName || null,
          appointeeBankAccountNumber: item.appointeeBankAccountNumber || null,
          appointeeIfscCode: item.appointeeIfscCode || null
          // captureAppointeeBankDetails: !!item.appointeeBankName,
          // captureAppointeeAddress: !!item.appointeeAddress
        };
      }
      return obj;
    });
    const response: any = await axiosInstance.put(
      API_URLS.setNomineeDetails,
      updatedNomineeDetails
    );

    return response;
  } catch (response: any) {
    throw new Error(response?.message);
  }
};

export const deleteNomineeDetails = async (nomineeId: any) => {
  try {
    const response: any = await axiosInstance.delete(API_URLS.deleteNomineeDetails, {
      data: {
        id: nomineeId
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export default getNomineeDetails;
